/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: ec33x5SEN4aEEFQbKCmZsX
// Component: s_LAfngn8g9l
import * as React from "react";
import {
  PlasmicImg as PlasmicImg__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  useTrigger
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import ButtonNav from "../../ButtonNav"; // plasmic-import: mzFiKRs8rOn0/component
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: ec33x5SEN4aEEFQbKCmZsX/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic.module.css"; // plasmic-import: ec33x5SEN4aEEFQbKCmZsX/projectcss
import sty from "./PlasmicModuleNavLogo.module.css"; // plasmic-import: s_LAfngn8g9l/css
import image3223RKzkuuHy from "./images/image32.svg"; // plasmic-import: 23rKzkuu_-HY/picture
import image2JBmR49O2CvwD from "./images/image2.svg"; // plasmic-import: JBmR49O2CvwD/picture

createPlasmicElementProxy;

export const PlasmicModuleNavLogo__VariantProps = new Array();

export const PlasmicModuleNavLogo__ArgProps = new Array();

const $$ = {};

function PlasmicModuleNavLogo__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const [isRootHover, triggerRootHoverProps] = useTrigger("useHover", {});
  const triggers = {
    hover_root: isRootHover
  };
  const styleTokensClassNames = _useStyleTokens();
  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.root
      )}
      data-plasmic-trigger-props={[triggerRootHoverProps]}
    >
      <ButtonNav
        data-plasmic-name={"buttonNav"}
        data-plasmic-override={overrides.buttonNav}
        color={"white"}
        iconForButton={
          <PlasmicImg__
            data-plasmic-name={"img"}
            data-plasmic-override={overrides.img}
            alt={""}
            className={classNames(sty.img)}
            displayHeight={"100%"}
            displayMaxHeight={"none"}
            displayMaxWidth={"none"}
            displayMinHeight={"0"}
            displayMinWidth={"0"}
            displayWidth={"100%"}
            loading={"lazy"}
            src={
              triggers.hover_root
                ? {
                    src: image2JBmR49O2CvwD,
                    fullWidth: 256,
                    fullHeight: 256,
                    aspectRatio: 1
                  }
                : {
                    src: image3223RKzkuuHy,
                    fullWidth: 28,
                    fullHeight: 28,
                    aspectRatio: undefined
                  }
            }
          />
        }
        onClick={async () => {
          const $steps = {};
          $steps["goToHttpsO21PCom"] = true
            ? (() => {
                const actionArgs = { destination: "https://o21p.com/" };
                return (({ destination }) => {
                  if (
                    typeof destination === "string" &&
                    destination.startsWith("#")
                  ) {
                    document
                      .getElementById(destination.substr(1))
                      .scrollIntoView({ behavior: "smooth" });
                  } else {
                    location.assign(destination);
                  }
                })?.apply(null, [actionArgs]);
              })()
            : undefined;
          if (
            $steps["goToHttpsO21PCom"] != null &&
            typeof $steps["goToHttpsO21PCom"] === "object" &&
            typeof $steps["goToHttpsO21PCom"].then === "function"
          ) {
            $steps["goToHttpsO21PCom"] = await $steps["goToHttpsO21PCom"];
          }
        }}
        shape={"fullRounding"}
        slotSize={"fillButton"}
        status={"normal"}
      />
    </div>
  );
}

const PlasmicDescendants = {
  root: ["root", "buttonNav", "img"],
  buttonNav: ["buttonNav", "img"],
  img: ["img"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicModuleNavLogo__ArgProps,
          internalVariantPropNames: PlasmicModuleNavLogo__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicModuleNavLogo__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicModuleNavLogo";
  } else {
    func.displayName = `PlasmicModuleNavLogo.${nodeName}`;
  }
  return func;
}

export const PlasmicModuleNavLogo = Object.assign(
  // Top-level PlasmicModuleNavLogo renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    buttonNav: makeNodeComponent("buttonNav"),
    img: makeNodeComponent("img"),
    // Metadata about props expected for PlasmicModuleNavLogo
    internalVariantProps: PlasmicModuleNavLogo__VariantProps,
    internalArgProps: PlasmicModuleNavLogo__ArgProps
  }
);

export default PlasmicModuleNavLogo;
/* prettier-ignore-end */
